import {Dimension, factor, X, Y} from '../../abstract-units';
import {CellAreaDefinition, CellAreaVertexDefinition, CellAreaVerticesDefinition} from '../area-definition';
import {CellAreaType} from '../cell-area-type';

const CENTER_AREA_SIZE_FR = [0.25, 0.25];
const CENTER_AREA_POS_FR = [
    (1 - CENTER_AREA_SIZE_FR[X]) / 2,
    (1 - CENTER_AREA_SIZE_FR[Y]) / 2
];

export const CENTER_CELL_AREA_DEF: CellAreaDefinition = {
    type: CellAreaType.CENTER,
    boxEdge: null,
    vertices: [
                  [0, 0], [1, 0], // TOP_LEFT, TOP_RIGHT
                  [0, 1], [1, 1] // BOTTOM_LEFT, BOTTOM_RIGHT
              ]
                  .map(axisSwitches => axisSwitches
                      .map((axisSwitch, axis: Dimension) =>
                          factor(axisSwitch * CENTER_AREA_SIZE_FR[axis] + CENTER_AREA_POS_FR[axis])
                      ) as CellAreaVertexDefinition
                  ) as CellAreaVerticesDefinition
};
